export enum SpouseTransactionInvolvement {
  None = -1,
  OnLoan = 1,
  OnTitleOnly = 2,
  NeitherOnLoanNorTitle = 3
}
